import { IImageEmbedFieldsFragment } from '../../utils/apollo/graphqlSchema';
import styled from 'styled-components';
import { AutoSizer } from 'react-virtualized';
import { useEffect, useState } from 'react';
import { IStyled } from '../../styles/types';

interface IProps extends IStyled {
  imageEmbed: IImageEmbedFieldsFragment;
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 150px;
`;

const Image = styled.img`
  padding: 8px;
  object-fit: contain;
`;

const ErrorContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
`;

const ImageEmbed = ({ imageEmbed, className }: IProps) => {
  const [error, setError] = useState(false);

  // reset the error state when the URL changes - it may load successfully this time
  useEffect(() => {
    setError(false);
  }, [imageEmbed.serveUrl]);

  return (
    <Wrapper className={className}>
      {!error ? (
        <AutoSizer>
          {({ width, height }) => (
            <Image
              src={imageEmbed.serveUrl}
              style={{ width, height }}
              onError={() => setError(true)}
            />
          )}
        </AutoSizer>
      ) : (
        <ErrorContainer>Image failed to load</ErrorContainer>
      )}
    </Wrapper>
  );
};

export default ImageEmbed;
